/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DocumentLink/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function DocumentLink({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/LinkedDocuments/Content/DocumentLink"
  
}) {
let linkedDocumentDocumentNameValueData = fromData.useDataValue({ viewPath,
context: 'linked_document',
path: 'document.name',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="ghost"
 onClick={onClick}
 width="100%"
 data="linked_document.document.name"
 text={linkedDocumentDocumentNameValueData}
/>
{children}
</React.Fragment>)
}